import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { setAuth } from "../lib/auth";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id: sessionId });
        setAuth(r.data.token, r.data.user);
        toast.success(`Selamat datang, ${r.data.user.name || r.data.user.email}!`);
      } catch (e) {
        toast.error(e.response?.data?.detail || "Login Google gagal");
      }
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/", { replace: true });
    })();
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center py-32 gap-4" data-testid="auth-callback-loading">
      <Loader2 className="w-8 h-8 animate-spin text-cyan1" />
      <p className="text-slate-400 font-mono text-sm">Memproses login Google...</p>
    </div>
  );
}
